<template>
  <div class="screen">
    <ActiveScreen v-if="hasActiveGame" />
    <InactiveScreen v-if="!hasActiveGame" />
  </div>
</template>

<script>
import InactiveScreen from "@/components/InactiveScreen.vue";
import ActiveScreen from "@/components/ActiveScreen.vue";

export default {
  name: "ClawView",
  components: {
    InactiveScreen,
    ActiveScreen,
  },
  data: () => ({
    activePlay: false,
  }),
  computed: {
    hasActiveGame() {
      const activeGameDiff = this.$store.getters.getActiveGameDiff;
      // Return true if game activity is within last 14 seconds (active game)
      // Return false if no data or game is older than 14 seconds (inactive)
      return activeGameDiff !== null && activeGameDiff < 14;
    },
  },
  created() {
    this.timer = setInterval(this.getActivePlay, 2000);
  },
  methods: {
    getActivePlay() {
      this.$store.dispatch("getActiveGame");
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
h1 {
  font-size: 200px;
  color: #26231d;
  padding-bottom: 20px;
}
img {
  padding-bottom: 20px;
}
.outer {
  display: flex;
  align-items: center;
}
.center {
  margin: auto;
  /* padding: 10px; */
}
.screen {
  background: url("~@/assets/screen_bg.svg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  min-height: 100vh;
  /* background-color: #26231d; */
  overflow: hidden; /* Hide scrollbars */
}
</style>
